<ng-container *ngIf="items?.length">
  <div class="tag-selection-wrapper">
    <div
      class="tag-item"
      *ngFor="let tag of items; let last = last"
      [class.active]="tag.active"
      [class.last]="last"
      (click)="toggleActive(tag)"
    >
      {{ tag.key | translate }}
    </div>

    <div class="tag-resetter" [class.active]="activeItems.length" (click)="resetFilters()">
      {{ 'RESET_SELECTION' | translate }}
    </div>

    <div class="tag-right-spacer"></div>
  </div>
</ng-container>
